import React from "react";
import { Col, Row } from "react-bootstrap";
import emailSubLogo from "../../../../../../img/email_icon.png";
import smsSubLogo from "../../../../../../img/sms_icon.png";
import numberSubLogo from "../../../../../../img/number_icon.png";
import NumberFormat from "react-number-format";
import { FadeButton, SolidButton } from "../../../../../library/button";
import { useDispatch } from "react-redux";
import "./style.scss";
import {
  changeCompanyModal,
  setActiveSubscription,
} from "../../../../../../redux/actions/company";

const Index = ({ subscription, removeSubscription, last }) => {
  const dispatch = useDispatch();

  const renderIcon = () => {
    if (subscription) {
      switch (subscription.type) {
        case "email":
          return emailSubLogo;
        case "sms":
          return smsSubLogo;
        case "number":
          return numberSubLogo;
        default:
          return null;
      }
    }
  };

  const renderTitle = () => {
    if (subscription) {
      switch (subscription.type) {
        case "email":
          return "Ekstra e-postutsendelser";
        case "sms":
          return "Ekstra sms-utsendelser";
        case "number":
          return "Nummer til sms-utsendelser";
        default:
          return "";
      }
    }
  };

  const renderChannelSenders = (output) => {
    if (output) {
      if (output.length === 1) {
        return output[0].username;
      } else if (output.length === 2) {
        return `${output[0].username} og ${output[1].username}`;
      } else {
        return `${output.slice(0, 2).join(", ")} og ${
          output.length - 2
        } andre kanaler.`;
      }
    }
  };

  const renderDescription = () => {
    if (subscription) {
      return `For ${renderChannelSenders(subscription?.details?.channels)}.`;
    }
  };

  const clickDelete = () => {
    dispatch(
      setActiveSubscription({
        id: subscription.id,
        type: subscription.type,
        channels: subscription?.details?.channels,
      })
    );
    dispatch(changeCompanyModal({ cancelSubscription: true }));
  };

  return (
    <div className={`other-subscription-container ${last ? "bottom" : ""}`}>
      <div className="inner-other-subscription-container">
        <Row className="subscription-row">
          <Col className="icon-col my-auto text-left">
            <img className="logo" src={renderIcon()} />
          </Col>
          <Col className="license-col my-auto text-left">
            <h2 className="card-title">{renderTitle()}</h2>
            <p className="card-description">{renderDescription()}</p>
          </Col>
          <Col className="price-col my-auto text-center">
            <h2 className="card-title">
              <NumberFormat
                displayType={"text"}
                thousandSeparator={" "}
                value={subscription.price / 100}
              />
              kr
            </h2>
            <p className="card-description">per måned</p>
          </Col>
          <Col className="button-col my-auto">
            <SolidButton
              disabled
              size="md"
              title="Endre"
              spacing="right"
              color="gray"
            />
            <SolidButton
              onClick={() => clickDelete()}
              size="md"
              title="Slett"
              spacing="right"
              color="gray"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Index;
